import React from 'react';
import DateUtils from "../../../../../monitoring/src/Utils/DateUtils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const IconTableColumn = (icon) => ((props) => {

    const {Value} = props;

    return Value ? <FontAwesomeIcon icon={icon} /> : null;
});
